import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './AnalyticsRealTimeColumnsContainer.scss';

import AnalyticsRealTimeColumns from '../AnalyticsRealTimeColumns/AnalyticsRealTimeColumns';

import useDetectDevice from '../../../functionality/Hooks/detectDevice';

const AnalyticsRealTimeColumnsContainer = ({ setSection, subSection }) => {
  const {
    // tmxMessagesContact,
    liveUsers,
    liveMessages,
    signals,
    customAssociatedConversation,

    // loadingInitialTmxMessagesContact,
    loadingInitialLiveUsers,
    loadingInitialLiveMessages,
    loadingInitialSignals,
    loadingInitialCustomAssociatedConversation,

    // loadingMoreTmxMessagesContact,
    loadingMoreLiveUsers,
    loadingMoreLiveMessages,
    loadingMoreSignals,
    loadingMoreCustomAssociatedConversation
  } = useSelector((state) => state.analyticsDashboardReducer);

  const isMobile = useDetectDevice(520);

  const [currentCollection, setCurrentCollection] = useState('live_messages');

  const [hideHover, setHideHover] = useState(false);

  const [showDropDown, setShowDropDown] = useState(false);

  const dropDownOptions = [
    { name: 'Active Users', icon: 'tracker-user', collectionType: 'live_users' },
    { name: 'Real-Time Chat', icon: 'messages-2', collectionType: 'live_messages' },
    { name: 'Real-Time search', icon: 'messages-2', collectionType: 'live_replies' }
  ];

  const setDropDownValue = (event, collectionType) => {
    event.preventDefault();
    setShowDropDown(!showDropDown);
    localStorage.setItem('AccessDashboardMobileSelection', collectionType);
  };

  const dropDownRef = useRef(null);

  useEffect(() => {
    /**
     * close dropDown clicked on outside of element
     */
    function handleClickOutside(event) {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropDownRef, showDropDown]);

  return (
    <>
      <section
        className={classNames('tmx-analyticsRealTimeColumnsContainer__listsContainer', {
          'tmx-analyticsRealTimeColumnsContainer__listsContainer--hide': false
        })}>
        <div
          className={classNames('tmx-analyticsRealTimeColumnsContainer__dashboardGroupContainer', {
            'tmx-analyticsRealTimeColumnsContainer__dashboardGroupContainer--mobile': isMobile
          })}>
          <div
            className={classNames('tmx-analyticsRealTimeColumnsContainer__groupTitleContainer2')}>
            <p className="tmx-analyticsRealTimeColumnsContainer__groupTitle">Messenger</p>
          </div>
          <AnalyticsRealTimeColumns
            setSection={setSection}
            toolTipContent={'Users engaging with TMX in the past 24 hours.'}
            // collectionType={'active_users'}
            collectionType={'live_users'}
            iconName={'tracker-user'}
            iconSize={'huge'}
            title={'Active Users'}
            cardType={0}
            data={liveUsers}
            loading={loadingInitialLiveUsers}
            loadingMore={loadingMoreLiveUsers}
            isMobile={isMobile}
            showDropDown={showDropDown}
            setShowDropDown={setShowDropDown}
            setDropDownValue={setDropDownValue}
            dropDownRef={dropDownRef}
            dropDownOptions={dropDownOptions}
            hideHover={hideHover}
            setHideHover={setHideHover}
            currentCollection={currentCollection}
            setCurrentCollection={setCurrentCollection}></AnalyticsRealTimeColumns>

          <AnalyticsRealTimeColumns
            setSection={setSection}
            toolTipContent={null}
            hideTooltip
            collectionType={'live_messages'}
            iconName={'messages-2'}
            iconSize={'huge'}
            title={'Real-Time input'}
            collection={'invites'}
            cardType={1}
            data={liveMessages}
            loading={loadingInitialLiveMessages}
            loadingMore={loadingMoreLiveMessages}
            isMobile={isMobile}
            showDropDown={showDropDown}
            setShowDropDown={setShowDropDown}
            setDropDownValue={setDropDownValue}
            dropDownRef={dropDownRef}
            dropDownOptions={dropDownOptions}
            hideHover={hideHover}
            setHideHover={setHideHover}
            currentCollection={currentCollection}
            setCurrentCollection={setCurrentCollection}></AnalyticsRealTimeColumns>

          <AnalyticsRealTimeColumns
            setSection={setSection}
            toolTipContent={null}
            hideTooltip
            collectionType={'live_replies'}
            iconName={'messages-2'}
            iconSize={'huge'}
            title={'Real-Time search'}
            collection={'invites'}
            cardType={1}
            data={customAssociatedConversation}
            loading={loadingInitialCustomAssociatedConversation}
            loadingMore={loadingMoreCustomAssociatedConversation}
            isMobile={isMobile}
            showDropDown={showDropDown}
            setShowDropDown={setShowDropDown}
            setDropDownValue={setDropDownValue}
            dropDownRef={dropDownRef}
            dropDownOptions={dropDownOptions}
            hideHover={hideHover}
            setHideHover={setHideHover}
            currentCollection={currentCollection}
            setCurrentCollection={setCurrentCollection}></AnalyticsRealTimeColumns>

          <AnalyticsRealTimeColumns
            setSection={setSection}
            toolTipContent={null}
            hideTooltip
            collectionType={'live_signals'}
            iconName={'messages-2'}
            iconSize={'huge'}
            title={'Signals'}
            collection={'invites'}
            cardType={1}
            data={signals}
            loading={loadingInitialSignals}
            loadingMore={loadingMoreSignals}
            isMobile={isMobile}
            showDropDown={showDropDown}
            setShowDropDown={setShowDropDown}
            setDropDownValue={setDropDownValue}
            dropDownRef={dropDownRef}
            dropDownOptions={dropDownOptions}
            hideHover={hideHover}
            setHideHover={setHideHover}
            currentCollection={currentCollection}
            setCurrentCollection={setCurrentCollection}></AnalyticsRealTimeColumns>
        </div>
      </section>

      {/* Hiding this for now */}
      {/* <section
        className={classNames(
          'tmx-analyticsRealTimeColumnsContainer__listsContainer tmx-analyticsRealTimeColumnsContainer__listsContainer--paddingRight'
        )}>
        <div
          className={classNames('tmx-analyticsRealTimeColumnsContainer__dashboardGroupContainer')}>
          <div
            className={classNames('tmx-analyticsRealTimeColumnsContainer__groupTitleContainer2')}>
            <p className="tmx-analyticsRealTimeColumnsContainer__groupTitle">My TMX Inbox</p>
          </div>
          <AnalyticsRealTimeColumns
            toolTipContent={null}
            hideTooltip
            collectionType={'clearedarticles'}
            iconName={'messages-2'}
            iconSize={'huge'}
            title={'TMX Inbox'}
            cardType={1}
            data={tmxInbox}
            loading={loadingInitialtmxInbox}
            loadingMore={loadingMoreTmxInbox}></AnalyticsRealTimeColumns>

          <AnalyticsRealTimeColumns
            toolTipContent={'List of Stories that TMX is intersted in syndicating from newsrooms.'}
            collectionType={'pitches'}
            iconName={'pitches-2'}
            iconSize={'huge'}
            title={'Pitches'}
            cardType={1}
            data={pitches}
            loading={loadingInitialPitches}
            loadingMore={loadingMorePitches}></AnalyticsRealTimeColumns>
        </div>
      </section> */}

      {/* <section
        className={classNames(
          'tmx-analyticsRealTimeColumnsContainer__listsContainer tmx-analyticsRealTimeColumnsContainer__listsContainer--paddingRight'
        )}>
        <div
          className={classNames('tmx-analyticsRealTimeColumnsContainer__dashboardGroupContainer')}>
          <div
            className={classNames('tmx-analyticsRealTimeColumnsContainer__groupTitleContainer2')}>
            <p className="tmx-analyticsRealTimeColumnsContainer__groupTitle">Test Collection</p>
          </div>

          <AnalyticsRealTimeColumns
            setSection={setSection}
            toolTipContent={'Users engaging with TMX in the past 24 hours.'}
            collectionType={'newsroom_analytics'}
            iconName={'tracker-user'}
            iconSize={'huge'}
            title={'Newsroom Analytics'}
            cardType={1}
            data={newsRoomAnalytics}
            loading={loadingInitialNewsRoomAnalytics}
            loadingMore={loadingMoreNewsRoomAnalytics}
            redact={true}></AnalyticsRealTimeColumns>
        </div>
      </section> */}
    </>
  );
};

AnalyticsRealTimeColumnsContainer.propTypes = {
  signUp: PropTypes.any,
  setSection: PropTypes.func,
  subSection: PropTypes.string
};

export default AnalyticsRealTimeColumnsContainer;
